export const STORAGE_IE_TIME_KEY = 'ie11_time';
export const STORAGE_IE_TIME_STRING = `;${STORAGE_IE_TIME_KEY}=`;
export const STORAGE_EVENT_CMD = 'll.event';
export const STORAGE_RESPONSE_CMD = 'll.response';
export const STORAGE_READY_CMD = 'ready';
export const ERROR_STORAGE_UNAVAILABLE = 'ERR_STORAGE_UNAVAILABLE';
export const ERROR_ENVIRONMENT = 'ERR_UNSUPPORTED_ENV';
export const ERROR_PROMISE_TIMEOUT = 'ERR_PROMISE_TIMEOUT';
export const ERROR_REQUEST_TIMEOUT = 'ERR_REQUEST_TIMEOUT';
export const ERROR_TIMEOUT = 'ERR_TIMEOUT';
export const ERROR_NO_ARGS = 'ERR_MISSING_ARGS';
export const ERROR_CONTEXT_LOCKED = 'ERR_ALREADY_LOCKED';
export const ERROR_NO_STORAGE_MANAGER = 'ERR_STORAGE_MANAGER_MISSING';
export const ERROR_OPERATION_FAILED = 'ERR_FAILED';
export const ERROR_COMPONENT_MISSING = 'REQUIRED_COMPONENT_MISSING';
export const ERROR_NETWORK_TIMEOUT = 'ERROR_NETWORK_TIMEOUT';
export const INSTANCE_CONFIG_ERROR = 'ERROR_INSTANCE_NOT_CONFIGURED';
export const ERROR_REVERSE_ALREADY_ACTIVE = 'ERR_REVERSE_ALREADY_ACTIVE';
export const ERROR_REVERSE_VIEW_INACTIVE = 'ERR_VIEW_INACTIVE';
export const SESSION_IN_PROGRESS = 'IN_PROGRESS';
